/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Description_LabelInputs */

const en_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Description`)
};

const fr_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du projet`)
};

const de_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektbeschreibung`)
};

const it_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione del progetto`)
};

const ru_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание проекта`)
};

const es_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción del proyecto`)
};

const zh_cn2_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目描述`)
};

const ja_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの説明`)
};

const hi_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना विवरण`)
};

const pt_pt2_project_description_label = /** @type {(inputs: Project_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição do projeto`)
};

/**
* | output |
* | --- |
* | "Project Description" |
*
* @param {Project_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_description_label = /** @type {((inputs?: Project_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_description_label(inputs)
	if (locale === "de") return de_project_description_label(inputs)
	if (locale === "it") return it_project_description_label(inputs)
	if (locale === "ru") return ru_project_description_label(inputs)
	if (locale === "es") return es_project_description_label(inputs)
	if (locale === "zh-CN") return zh_cn2_project_description_label(inputs)
	if (locale === "ja") return ja_project_description_label(inputs)
	if (locale === "hi") return hi_project_description_label(inputs)
	if (locale === "pt-PT") return pt_pt2_project_description_label(inputs)
	return en_project_description_label(inputs)
});